import NewSelect from './newSelect.vue';

NewSelect.install = (Vue) => {
  Vue.component(NewSelect.name, NewSelect);
};

export default NewSelect;
